<template>
  <div>
    <div
      class="modal"
      tabindex="0"
      :id="modalID"
      data-bs-backdrop="static"
      aria-labelledby=""
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered"
        :class="{ 'modal-xl': modalSize === 'xl','modal-lg': modalSize === 'lg', 'modal-sm': modalSize === 'sm' }"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="modalTitle">{{ modalTitle }}</h5>
            <button
              v-if="showCloseButton"
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close modal"
              tabindex="0"
            ></button>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer">
            <div>
              <button
              type="button"
              class="button"
              :class="buttonSize"
              data-bs-dismiss="modal"
              v-if="showSecondaryButton"
              @click="onSecondaryButtonClick()"
              :aria-label="secondaryButtonName"
              tabindex="0"
            >
              {{ secondaryButtonName }}
            </button>
            <button
              type="button"
              class="button margin-left-10"
              :class="buttonSize"
              data-bs-dismiss="modal"
              v-if="showPrimaryButton"
              :aria-label="primaryButtonName"
              tabindex="0"
              @click="onPrimaryButtonClick()"
              >{{ primaryButtonName }}</button
            >
            </div>
            <div>
              <p class="modal-footer-text">{{ modalFooterText }}.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  props: [
    "modalID",
    "modalSize",
    "showSecondaryButton",
    "showPrimaryButton",
    "buttonSize",
    "modalTitle",
    "showCloseButton",
    "secondaryButtonName",
    "primaryButtonName",
    "modalFooterText",
  ],
  emits: ['primaryButtonClicked', 'secondaryButtonClicked'],
  methods: {
    onPrimaryButtonClick() {
      this.$emit("primaryButtonClicked");
    },
    onSecondaryButtonClick() {
      this.$emit("secondaryButtonClicked");
    }
  }
};
</script>
<style scoped>
  @media only screen and (max-width: 599px) {
    .margin-left-10 {
      margin: 0px;
    }
  }
</style>
